<template>
  <v-btn 
    color="primary"
    rounded
    @click="login"
  >
    <v-icon v-if="icon" left>{{ icon }}</v-icon>
    <span v-if="text">{{ text }}</span>
  </v-btn>
</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'Login',
    props: {
      text: String,
      icon: String
    },
    data () {
      return {
        googleAuth: new firebase.auth.GoogleAuthProvider()
      }
    },
    methods: {
      login () {
        firebase.auth().signInWithPopup(this.googleAuth)
        .then((result) => {
          // give time for the firebase function to create
          // new user records if this is a new user
          
          // TODO: make this into a function that can only be called once
          if (result.additionalUserInfo.isNewUser) {
            this.$store.dispatch('setLoadingApp', true)
            this.$store.dispatch('createRecords', {
              table: 'Users',
              records: [{
                fields: {
                  'Name': result.user.displayName,
                  'Firebase ID': result.user.uid
                }
              }]
            })
            .then(async values => {
              const airtableRecord = values[0].data[0]
              const firestoreData = {
                name: airtableRecord.fields.Name,
                airtableRecordId: airtableRecord.id
              }
              await firebase.firestore().collection('users')
                    .doc(result.user.uid).set(firestoreData)
              this.redirectAfterLogin()
            })
          } else {
            this.redirectAfterLogin()
          }
        })
        .catch((err) => {
          console.error(err)
        })
      },
      redirectAfterLogin () {
        if (this.$route.query && this.$route.query.from) {
          return this.$router.replace(this.$route.query.from)
        }
        return this.$router.push({ name: 'Home' })
      }
    }
  }
</script>
